<template>
    <div class="true-panel"
         :class="{'shadow': shadow}">
        <slot></slot>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: {
    shadow: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    ...mapState([])
  },
  methods: {
    ...mapActions([])
  }
};
</script>

<style lang="css"></style>
